<app-exg-select-v2 [listDisplay]="listDisplay"
                   [list]="list"
                   [caption]="caption"
                   [required]="required"
                   [disabled]="disabled"
                   [(ngModel)]="valueIndex"
>
</app-exg-select-v2>
